<script>
import baseMixin from '@/mixins/baseMixin'
import bookingDetailsMixin from '@/mixins/bookingDetailsMixin'
import dayjs from '@/services/date/index'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'

export default {
  name: 'BookingDetailsTabDays',
  mixins: [baseMixin, bookingDetailsMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      layout: 'calendar',
    }
  },
  computed: {
    mapDatesForCalendar() {
      return this.booking.dates.map((bookingDate) => bookingDate.date)
    },
    isABookingRequest() {
      return this.isBookingRequest(this.booking.status)
    },
    showCalendar() {
      return this.layout === 'calendar'
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format(DateFormatToken.ddddLL)
    },
  },
}
</script>

<template>
  <div class="mt-4">
    <div class="d-flex justify-end">
      <v-btn-toggle v-model="layout" dense class="mb-4" color="primary">
        <v-btn value="calendar">
          <v-icon>mdi-calendar</v-icon>
        </v-btn>

        <v-btn value="table">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-date-picker
      v-if="showCalendar"
      v-model="mapDatesForCalendar"
      readonly
      color="primary"
      show-adjacent-months
      multiple
      no-title
      full-width
    ></v-date-picker>

    <v-simple-table v-else fixed-header height="300px">
      <template v-slot>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('booking.details.days.table.idColumn') }}
            </th>
            <th class="text-left">
              {{ $t('booking.details.days.table.dateColumn') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in booking.dates" :key="item.id">
            <td>{{ `${isABookingRequest ? 'REF#' : ''}` }}{{ item.id }}</td
            ><td>
              {{ formatDate(item.date) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
